import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["groupIndex", "typeConfig", "restConfig", "Render", "prefix"];

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-13 15:32:55
 * @LastEditTime: 2021-11-17 15:40:32
 * @LastEditors: wangshengqiang
 * @Description: 受益人
 */
import React, { useState, useEffect, useCallback } from 'react';
import { updateFormKey } from '@/utils/tool';
import { getFormValue, setFormValue, useStore } from '@/store'; // import { listenBehavior } from '@/store/behavior';

import ItemRender from './ItemRender';
import { AddableBlock } from '../common';

function isNamedBeneficiary(type) {
  return type === 'specialBeneficiary';
}

export default function BeneficiaryItem(props) {
  var _config1$, _typeConfig$;

  const {
    groupIndex,
    typeConfig,
    restConfig,
    Render,
    prefix
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const config1 = updateFormKey(typeConfig, 0) || [{}];
  const beneficiaryType = useStore(`formValues.${(_config1$ = config1[0]) === null || _config1$ === void 0 ? void 0 : _config1$.formKey}`);
  const beneficiaryArr = typeConfig[0] && getFormValue((_typeConfig$ = typeConfig[0]) === null || _typeConfig$ === void 0 ? void 0 : _typeConfig$._formValueKey) || []; // 判断指定受益人时显示其他信息录入项

  const isShowOther = isNamedBeneficiary(beneficiaryType);
  const [preview, setPreview] = useState(false); // 为了触发受益人也同步增加一个

  const handleCountChange = ({
    type,
    count
  }) => {
    if (type === 'add') {
      setFormValue(`beneficiary[${groupIndex}][${count - 1}].beneficiaryType`, 'specialBeneficiary');
    }
  };

  const handlerMessage = useCallback(e => {
    const {
      preview: _preview
    } = e;
    setPreview(_preview);
  }, []); // 处理受益人类型变更时 清楚受益人其他信息

  useEffect(() => {
    // 解决初始默认值不会存进store的问题
    if (!isShowOther) {
      var _typeConfig$2;

      setFormValue((_typeConfig$2 = typeConfig[0]) === null || _typeConfig$2 === void 0 ? void 0 : _typeConfig$2._formValueKey, [{
        beneficiaryType: 'legalBeneficiary'
      }]);
    }
  }, [isShowOther]);
  useEffect(() => {// const unlisten = listenBehavior(handlerMessage, 'beneficiaryModule');
    // return () => {
    //   unlisten();
    // };
  }, [handlerMessage]); // ;

  const isShow = isShowOther || preview;
  return /*#__PURE__*/React.createElement("div", {
    className: "c-beneficiary__item"
  }, /*#__PURE__*/React.createElement(Render, {
    components: config1
  }), isShow && /*#__PURE__*/React.createElement(AddableBlock, _extends({
    Component: ItemRender,
    config: restConfig,
    initCount: beneficiaryArr.length,
    maxCount: 100,
    formValueArrayKey: typeConfig[0]._formValueKey,
    addButtonText: `添加${prefix}`,
    Render: Render,
    prefix: prefix,
    onCountChange: handleCountChange,
    preview: preview
  }, rest)));
}